import React from 'react';
import './Footer.css';
import { FaTwitter, FaGithub, FaLinkedin } from 'react-icons/fa';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>QED AI</h3>
          <p>Designing the autonomous future: Scaling AI Agents in production environments.</p>
        </div>
        <div className="footer-section">
            <h4>Resources</h4>
            <ul>
                <li><a href="/">Blog</a></li>
                <li><a href="/">System Design Primer</a></li>
                <li><a href="/">Interview Guide</a></li>
                <li><a href="/feedback">Report an issue</a></li>
            </ul>
        </div>
        <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-icons">
                <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
                    {React.createElement(FaTwitter as any)}
                </a>
                <a href="https://github.com/gutsycoder" target="_blank" rel="noreferrer" aria-label="GitHub">
                    {React.createElement(FaGithub as any)}
                </a>
                <a href="https://www.linkedin.com/in/suyash-saxena-abb01b1b5/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                    {React.createElement(FaLinkedin as any)}
                </a>
            </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} QED System Design. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
